var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础配置',path:'/shop/plugin/cmo/conf'},
    {title:'总监管理',path:'/shop/plugin/cmo/manage'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }